import { create } from "jss";
import { useSnackbar } from "notistack";
import React, { useContext } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Alert, Snackbar, Slide } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { HelmetProvider, Helmet } from "react-helmet-async";
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import createTheme from "./theme";
import Router from "./router/Router";
import "./pages/welcome page components/style.css";
import "./pages/css components/style.css";
import { closeAlert } from "./redux/slices/alertSlice";
import { ThemeContext } from "./components/ThemeProvider";
import AuthVerification from "./components/AuthVerification";

// const history = createBrowserHistory({ basename: "/v1" });

function App() {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const alert = useSelector((state) => state.alertDetails);
  const { theme } = useContext(ThemeContext);
  return (
    <HelmetProvider>
      <Helmet
        titleTemplate="%s | Publicis"
        defaultTitle="ADN-Publicis Dashboard"
      />
      <StyledEngineProvider injectFirst>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={createTheme(theme)}>
              <ThemeProvider theme={createTheme(theme)}>
                {alert.multiple ? (
                  alert.multiple.map((msg) => (
                    <div style={{ display: "none" }}>
                      {enqueueSnackbar(msg, {
                        variant: alert.type,
                        autoHideDuration: 4000,
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                      })}
                    </div>
                  ))
                ) : (
                  <Snackbar
                    open={alert.state}
                    autoHideDuration={4000}
                    onClose={handleAlertClose}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    slots={{ transition: SlideTransition }}
                    sx={{
                      top: 8,
                      right: 10,
                      pointerEvents: "none",
                      zIndex: 1400,
                    }}
                  >
                    <Alert
                      variant="filled"
                      severity={alert.type}
                      onClose={handleAlertClose}
                      sx={{ minWidth: 350, pointerEvents: "auto" }}
                    >
                      {alert.message}
                    </Alert>
                  </Snackbar>
                )}

                <Router />
                <AuthVerification />
              </ThemeProvider>
            </MuiThemeProvider>
          </StyledEngineProvider>
        </LocalizationProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  );

  function SlideTransition(props) {
    return <Slide {...props} direction="right" />;
  }

  function handleAlertClose(_, reason) {
    if (reason === "clickaway") {
      return;
    }

    dispatch(closeAlert());
  }
}

export default App;

// "@mui/icons-material": "^5.16.7",
// "@mui/lab": "^5.0.0-alpha.173",
// "@mui/material": "^5.16.7",
// "@mui/styled-engine-sc": "^5.14.12",
// "@mui/styles": "^5.16.7",
// "@mui/system": "^5.16.7",
// "@mui/x-date-pickers": "^5.0.0",
// "@mui/x-date-pickers-pro": "^5.0.0-alpha.7",
